import PageModel from '@/models/pageModel';

export class Clinics extends PageModel {
    static moduleName = 'clinics';
    static moduleEntityName = 'clinic';
    static listTitle = 'Клиники';
    static createTitle = 'Добавление новой клиники';
    static apiPrefix = 'clinics';
}
